
//Bootstrap
import 'bootstrap';

//FontAwesome
import fontawesome from '@fortawesome/fontawesome';
import solid from '@fortawesome/fontawesome-free-solid';

fontawesome.library.add(solid.faTrash);
fontawesome.library.add(solid.faClipboard);
fontawesome.library.add(solid.faInfo);
fontawesome.library.add(solid.faCar);



// WEBPACK FOOTER //
// ./src/assets/scripts/imports.js